import React, { Component } from 'react';
import styled from 'styled-components';
import Select from '../../../components/Select/SelectFilter';
import DatePickerInput from '../../../components/DatePicker';
import { I18n } from 'react-redux-i18n';

const AuctionFiltersContainer = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  padding: 25px;
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 4px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    grid-template-columns: 1fr;
    align-items: center;
  }
`;

const dateStyle = `
  .SingleDatePickerInput{
    border: 0;
    border-bottom: 1px solid rgba(134,142,150,0.3);
    height: 25px;
    background-color:transparent;
  } 
  .DateInput{
    height: 25px;
    margin-left: 0px;
    background-color:transparent;
  } 
  .DateInput_input{
    height: 25px;
    background-color:transparent;
  }
  .SingleDatePicker_picker{
    margin-left: 40px;
    top: 35px !important;
  }

  .DateInput_fangShape{
    fill: #fbfcfc;
  }

  .DateInput_fang{
    top: 25px !important;
    left: 85px !important;
  }
`;

class AuctionFilters extends Component {
  constructor(props) {
    super(props);
    this.state = { focusedStart: false, focusedEnd: false };
  }
  render() {
    const { options, selection, onChange } = this.props;
    const { focusedStart, focusedEnd } = this.state;

    return (
      <AuctionFiltersContainer>
        <Select
          label={I18n.t('auction.auction.wine')}
          isClearable={false}
          options={options.client_wines}
          value={selection.wine}
          onChange={(value) => onChange('wine', value)}
        />
        <DatePickerInput
          focused={focusedStart}
          onFocusChange={(focusedStart) => this.setState({ focusedStart })}
          onChange={(date) => onChange('startDate', date)}
          label={I18n.t('auction.auction.from')}
          date={selection.startDate}
          styles={dateStyle}
        />
        <DatePickerInput
          focused={focusedEnd}
          onFocusChange={(focusedEnd) => this.setState({ focusedEnd })}
          onChange={(date) => onChange('endDate', date)}
          date={selection.endDate}
          label={I18n.t('auction.auction.at')}
          styles={dateStyle}
        />
        <Select
          label={I18n.t('auction.auction.store')}
          options={options.stores}
          placeholder={I18n.t('placeholderAll2')}
          value={selection.store}
          onChange={(value) => onChange('store', value)}
        />
        <Select
          label={I18n.t('restaurants&caves.filters.market')}
          placeholder={I18n.t('placeholderAll')}
          options={options.markets}
          value={selection.market}
          onChange={(value) => onChange('market', value)}
        />
      </AuctionFiltersContainer>
    );
  }
}

export default AuctionFilters;
